import React, { Component } from 'react'
import { Doughnut } from 'react-chartjs-2'
import { inject, observer } from 'mobx-react'
import Countdown from 'react-countdown-now';
import { Card, Icon, List, Dropdown, message, Menu, InputNumber, Tooltip } from 'antd'
import PropBets from './PropBets'
import Modal from 'react-modal'
import PoolDataChart from './PoolDataChart'
import FollowTeamBtn from './followButtons/FollowTeamBtn';
import { finalizeEvent as finalizeApiEvent } from '../../api-calls/events'
import { finalizeEvent as finalizeContractEvent } from '../../contract/Events'
import { cancelEvent as cancelApiEvent } from '../../api-calls/events'
import { cancelEvent as cancelContractEvent } from '../../contract/Events'
import { makeWager as makePoolWagerContract } from '../../contract/PoolWagersController'
import { makeWager as makePoolWagerApi } from '../../api-calls/poolWagers'
import { FaSwimmingPool, FaHandshake, FaCoins, FaTicketAlt } from 'react-icons/fa';
import AvailableBets from './AvailableBets';
import { utils } from 'web3';
import { ethMultiplier } from '../../constants';
import AvailableBetTable from './AvailableBetTable';

@observer(["AuthStore", "ViewStore", "eventStore", "AdminStore", "WagerStore", "BetSlipStore", "web3Store", "CustomRouter", "UserStore", "TeamStore", "CategoriesStore"])
class NewEventPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            backgroundPic: "https://i.imgur.com/bR8MBtT.jpg",
            finalizeModalVisible: false,
            cancelModalVisible: false,
            betTypeModalVisible: false,
            betTypeModalContent: <Icon type="loading" />,
            wagerValue: 0.05,
            estimatedWin: 0
        }
        this.setNewState = this.setNewState.bind(this);
        this.showFinalizeModal = this.showFinalizeModal.bind(this);
        this.handleFinalizeOk = this.handleFinalizeOk.bind(this);
        this.handleFinalizeCancel = this.handleFinalizeCancel.bind(this);
        this.onAdminMenuClick = this.onAdminMenuClick.bind(this);
        this.showCancelModal = this.showCancelModal.bind(this);
        this.handleCancelOk = this.handleCancelOk.bind(this);
        this.handleCancelCancel = this.handleCancelCancel.bind(this);
        this.handleBetTypeClose = this.handleBetTypeClose.bind(this);
        this.teamClicked = this.teamClicked.bind(this);
        this.addToBetSlip = this.addToBetSlip.bind(this);
        this.handleClickValue = this.handleClickValue.bind(this);
        this.handleValueChange = this.handleValueChange.bind(this);
        this.createPoolBet = this.createPoolBet.bind(this);
        this.poolClicked = this.poolClicked.bind(this);
        this.oneToOneForTeam = this.oneToOneForTeam.bind(this);
        this.oneToOneAgainstTeam = this.oneToOneAgainstTeam.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

   
    setNewState() {
        let self = this;

        let thisCategory = self.props.CategoriesStore.categories.get(self.props.eventStore.activeEvent.categoryId);
        self.setState({ thisCategory });
        self.setState({
            backgroundPic: thisCategory.picUrls[Math.floor(Math.random() * Math.floor(thisCategory.picUrls.length - 1))]
        });
    }
    showCancelModal = () => {
        this.setState({
            cancelModalVisible: true,
        });
    }

    showFinalizeModal = () => {
        this.setState({
            finalizeModalVisible: true,
        });
    }

    handleClickValue() {
        this.setState({ valueClicked: !this.state.valueClicked })
    }

    closeModal() {
        this.setState({ betTypeModalVisible: false });
    }

    createPoolBet() {
        let token = this.props.AuthStore.userAuth.auth.accessToken;
        let userId = this.props.UserStore.user._id;
        const { eventStore, UserStore } = this.props;
        let self = this;
        let event = eventStore.activeEvent;
        let eventId = event._id;
        let eventBytes32Id = event.bytes32Id;
        let value = this.state.wagerValue * ethMultiplier;
        let makerChoice = Number(this.state.makerChoice);
        let bytes32Id = utils.sha3(userId + eventId + (+Date.now()));      
        makePoolWagerContract(bytes32Id, eventBytes32Id, value, makerChoice).then(
            function (result) {
                if (String(result).includes('User denied transaction signature')) {
                    message.warning("Metamask transaction denied! No bet made.");
                } else {
                    return makePoolWagerApi(
                        token,
                        userId,
                        bytes32Id,
                        eventId,
                        value,
                        makerChoice,
                        false,
                        ""
                    ).then(function () {
                        self.setState({
                            betTypeModalVisible: false
                        })
                        return UserStore.updateUser(token);
                    })
                }
            })
    }


    handleValueChange(e) {
        const { eventStore, UserStore } = this.props;
        let event = eventStore.activeEvent;
        //console.log(parseFloat(e.target.value, 10));

        let totalBetAgainst = 0;
        event.amountBetForTeam.forEach(amount => {
            totalBetAgainst += amount;
        });

        if (event.drawPossible && this.state.index !== event.teams.length) {
            totalBetAgainst += event.amountBetForDraw;
        }

        let totalBetForChoiceSoFar = this.state.index == event.teams.length ? event.amountBetForDraw : (event.amountBetForTeam[this.state.index]);
        totalBetAgainst -= totalBetForChoiceSoFar;
        let estimatedWin = (totalBetAgainst == 0 ? (0).toFixed(4) : ((totalBetAgainst * ((Number(e) * ethMultiplier) / (totalBetForChoiceSoFar + (Number(e) * ethMultiplier)))) / ethMultiplier).toFixed(4));
        console.log(estimatedWin);
        if (e !== "") {

            this.setState({
                wagerValue: Number(e),
                // estimatedWin: (totalBetAgainst == 0 ? (0).toFixed(4) :
                //     ((totalBetAgainst * ((Number(e) * ethMultiplier) / (totalBetForChoiceSoFar + (Number(e) * ethMultiplier)))) / ethMultiplier).toFixed(4))
            });

            this.setState({
                betTypeModalContent: <div className="raleway">
                    {/* <button className="custom-btn-primary" onClick={this.teamClicked.bind(this, team, index)}>Go Back</button> */}
                    <span style={{ fontSize: "18pt", color: "#1890ff" }}>BETTING FOR {this.state.team.name.toUpperCase()}</span>
                    <br />
                    <br />
                    AMOUNT TO BET<div className="bet-slip-list-bet-value-amount" style={{ padding: '6px 2px 0px 2px', letterSpacing: '1px' }}>
                        {/* <input autoFocus onKeyPress={this.handleKeyPressValue} onBlur={this.handleClickValue} onChange={this.handleValueChange} className="bet-slip-value-input" type="number" value={(wager.value).toFixed(4)} /> */}
                        <InputNumber
                            precision={2}
                            min={0.05}
                            step={0.05}
                            onChange={this.handleValueChange}
                            className="bet-slip-value-input"
                            defaultValue={(this.state.wagerValue).toFixed(4)} />
                    </div>
                    <br />
                    ESTIMATED WIN <Tooltip title={<span>Based on current bets</span>} >
                        {/* <a href="https://mevu.bet/fees">Full Fee Breakdown</a></span>}> */}
                        <Icon type="question-circle" />
                    </Tooltip>   <span style={{ fontSize: "14pt", color: "#3ac55a" }}>{estimatedWin}</span>
                    <br />
                    <button className="custom-btn-success" onClick={this.createPoolBet}>CREATE BET <FaTicketAlt /></button>
                    <br />
                    {this.state.betData}
                </div>
            });
        }
    }

    poolClicked(betData, team, estimatedWin) {
        this.setState({
            betData: betData,
            team: team,
            betTypeModalContent: <div className="raleway">
                {/* <button className="custom-btn-primary" onClick={this.teamClicked.bind(this, team, index)}>Go Back</button> */}
                <span style={{ fontSize: "18pt", color: "#1890ff" }}>BETTING FOR {team.name.toUpperCase()}</span>
                <br />
                <br />
                AMOUNT TO BET<div className="bet-slip-list-bet-value-amount" style={{ padding: '6px 2px 0px 2px', letterSpacing: '1px' }}>
                    {/* <input autoFocus onKeyPress={this.handleKeyPressValue} onBlur={this.handleClickValue} onChange={this.handleValueChange} className="bet-slip-value-input" type="number" value={(wager.value).toFixed(4)} /> */}
                    <InputNumber
                        precision={2}
                        min={0.05}
                        step={0.05}
                        onChange={this.handleValueChange}
                        className="bet-slip-value-input"
                        defaultValue={(this.state.wagerValue).toFixed(4)} />
                </div>
                <br />
                ESTIMATED WIN <Tooltip title={<span>Based on current bets</span>} >
                    {/* <a href="https://mevu.bet/fees">Full Fee Breakdown</a></span>}> */}
                    <Icon type="question-circle" />
                </Tooltip>   <span style={{ fontSize: "14pt", color: "#3ac55a" }}>{estimatedWin}</span>
                <br />
                <button className="custom-btn-success" onClick={this.createPoolBet}>CREATE BET <FaTicketAlt /></button>
                <br />
                {betData}
            </div>
        });

    }


    teamClicked = (team, index, poolBool) => {
        const { eventStore, UserStore } = this.props;
        let event = eventStore.activeEvent;
        let betData = <PoolDataChart teams={eventStore.activeEvent.teams} event={event} />;
        let totalBetAgainst = this.state.wagerValue * ethMultiplier;
        event.amountBetForTeam.forEach(amount => {
            totalBetAgainst += amount;
        });
        if (event.drawPossible) {
            totalBetAgainst += event.amountBetForDraw;
        }

        console.log("makerChoice: " + (Number(index) + 1));
        console.log("total bet against1: " + totalBetAgainst);
        let totalBetForChoiceSoFar = 0;
        if (index == event.teams.length) {
            totalBetForChoiceSoFar = (event.amountBetForDraw + (this.state.wagerValue * ethMultiplier));
        } else {
            totalBetForChoiceSoFar = (event.amountBetForTeam[index]) + (this.state.wagerValue * ethMultiplier);
        }
        console.log("total bet so far1 " + totalBetForChoiceSoFar);
        totalBetAgainst -= totalBetForChoiceSoFar;
        console.log("total bet so far2 " + totalBetForChoiceSoFar);
        console.log("total bet against2: " + totalBetAgainst);
        let estimatedWin = (totalBetAgainst == 0 ? (0).toFixed(4) :
            ((totalBetAgainst * ((this.state.wagerValue * ethMultiplier) / (totalBetForChoiceSoFar))) / ethMultiplier).toFixed(4));

        this.setState({
            index: index,

            //  estimatedWin:
            //       (totalBetAgainst == 0 ? (0).toFixed(4) :
            //          ((totalBetAgainst * ((this.state.wagerValue * ethMultiplier) / (totalBetForChoiceSoFar))) / ethMultiplier).toFixed(4))
        });
        console.log("est win: " + estimatedWin);
        if (Date.now() / 1000 > event.startTime + event.duration) {
            message.info("Bet cannot be placed, event is over.")
        } else if (UserStore.user.role == "guest") {
            message.info("You must be logged in to place a bet.")
        } else {

            this.setState({
                betTypeModalVisible: true,
                makerChoice: (Number(index) + 1),

                // betTypeModalContent: 

                // <div>
                //     <h2>SELECT BET TYPE</h2>
                //     <br />
                //     <ul style={{ listStyleType: "none" }}>
                //         <li style={{ float: "left", padding: "24px" }}>
                //             <div
                //                 onClick={this.poolClicked.bind(this, betData)}
                //                 className="space-mono" style={{ textAlign: "center", fontSize: "18pt" }}>Pool
                //                 <br />
                //                 <FaCoins style={{ fontSize: "84pt" }} />
                //             </div>
                //         </li>
                //         <li style={{ float: "left", padding: "24px" }}>
                //             <div onClick={() => {
                //                 console.log("bet on " + team.name + " at " + index);
                //                 this.setState({
                //                     betTypeModalContent: <div>
                //                         {/* <button className="custom-btn-primary" onClick={this.teamClicked.bind(this, team, index)}>Go Back</button> */}
                //                         <br />
                //                         <button className="custom-btn-success" onClick={() => {
                //                             this.setState({ betTypeModalVisible: false });
                //                             // Add one to index because choice is the actual number (zero represents indeterminable, a number greater than num teams means a draw)
                //                             this.addToBetSlip(index + 1, team)
                //                         }}>CREATE NEW <FaTicketAlt /></button>
                //                         <br />
                //                         <br />
                //                         <AvailableBets team={team} teamChoice={index + 1} event={event} />
                //                         <br />
                //                     </div>
                //                 });


                //             }} className="space-mono" style={{ textAlign: "center", fontSize: "18pt" }}>
                //                 1-1
                //                 <br />
                //                 <FaHandshake style={{ fontSize: "84pt" }} />
                //             </div>
                //         </li>
                //     </ul>
                // </div>
            });

            if (poolBool) {
                this.poolClicked(betData, team, estimatedWin);

            }
        }

    }

    addToBetSlip(teamChoice, team) {
        const { BetSlipStore, web3Store } = this.props;     
        let selectedTeam = "";
        let thisEvent = this.props.eventStore.activeEvent;

        if (teamChoice == thisEvent.teams.length + 1) {
            selectedTeam = "Draw";
        } else {
            selectedTeam = team.name;
        }
        let bytes32_id = thisEvent.bytes32Id;
        let event_id = thisEvent._id;
        let start_time = thisEvent.startTime;
        let duration = thisEvent.duration;
        let team_one = thisEvent.teams[0];
        let team_two = thisEvent.teams[1];
        const wagerBytes32Id = utils.sha3(selectedTeam + event_id + teamChoice + (+Date.now()));
        console.log(wagerBytes32Id)
        BetSlipStore.WagerList.add({
            bytes32Id: wagerBytes32Id,
            eventId: event_id,
            eventBytes32Id: bytes32_id,
            maker: web3Store.account,
            value: 50000000000000000,
            odds: 100,
            makerChoice: teamChoice,
            settled: false,
            cancelled: false,
            selectedTeam: selectedTeam,
            team_one: team_one,
            team_two: team_two,
            eventStartTime: start_time,
            eventDuration: duration,
            isPropWager: false,
            originalEventId: "",
            isPrivate: false
        });
    }

    handleFinalizeOk = (e) => {
        const { eventStore, AuthStore } = this.props;
        console.log(e);
        this.setState({
            finalizeModalVisible: false,
        });
        let event = this.props.eventStore.activeEvent;
        let bytes_id = event.bytes32Id;
        return finalizeContractEvent(bytes_id).then(function (result) {
            if (String(result).includes('User denied transaction signature')) {
                message.warning("Metamask transaction denied! Event not finalized.");
            } else {
                return finalizeApiEvent(AuthStore.userAuth.auth.accessToken,
                    bytes_id).then(function () {

                        return eventStore.queryEvents();
                    });
            }
        });
    }

    handleCancelCancel = (e) => {      
        this.setState({
            cancelModalVisible: false,
        });
    }

    handleCancelOk = (e) => {
        const { CustomRouter } = this.props;
        const { eventStore, AuthStore } = this.props;
        const { router: { params } } = CustomRouter;     
        this.setState({
            cancelModalVisible: false,
        });
        let event = this.props.eventStore.activeEvent;
        let bytes_id = event.bytes32Id;
        return cancelContractEvent(bytes_id).then(function (result) {
            if (String(result).includes('User denied transaction signature')) {
                message.warning("Metamask transaction denied! Event not cancelled.");
            } else {
                return cancelApiEvent(AuthStore.userAuth.auth.accessToken,
                    bytes_id).then(function () {

                        return eventStore.queryEvents();
                    });
            }
        });
    }

    oneToOneForTeam(team, event, index) {
        if (event.teams.length == 2 && index < 2) {
            this.setState({
                betTypeModalVisible: true,
                betTypeModalContent: <div>
                    {/* <button className="custom-btn-primary" onClick={this.teamClicked.bind(this, team, index)}>Go Back</button> */}
                    <br />
                    <button className="custom-btn-success" onClick={() => {
                        this.setState({ betTypeModalVisible: false });
                        // Add one to index because choice is the actual number (zero represents indeterminable, a number greater than num teams means a draw)
                        this.addToBetSlip(index + 1, team)
                    }}>CREATE NEW <FaTicketAlt /></button>
                    <br />
                    <br />
                    <AvailableBets closeModal={this.closeModal.bind(this)} win={true} twoTeams={true} team={team} teamChoice={(index + 1 == 1 ? 2 : 1)} event={event} />
                    <br />
                </div>
            });

        } else {
            this.addToBetSlip(index + 1, team);
        }
    }

    oneToOneAgainstTeam(team, event, index) {
        if (event.teams.length == 2 && index < 2) {
            let teamChosenIndex = (index == 0 ? 1 : 0);
            let teamChosen = event.teams[teamChosenIndex];
            let teamChosenObject = this.props.TeamStore.teams.get(teamChosen);
            this.setState({
                betTypeModalVisible: true,
                betTypeModalContent: <div>
                    {/* <button className="custom-btn-primary" onClick={this.teamClicked.bind(this, team, index)}>Go Back</button> */}
                    <br />
                    <button className="custom-btn-success" onClick={() => {
                        this.setState({ betTypeModalVisible: false });
                        // Add one to index because choice is the actual number (zero represents indeterminable, a number greater than num teams means a draw)
                        this.addToBetSlip((index + 1 == 1 ? 2 : 1), teamChosenObject)
                    }}>CREATE NEW <FaTicketAlt /></button>
                    <br />
                    <br />
                    <AvailableBets closeModal={this.closeModal.bind(this)} win={false} twoTeams={true} team={team} teamChoice={index + 1} event={event} />
                    <br />
                </div>
            });
        } else {
            this.setState({
                betTypeModalVisible: true,
                betTypeModalContent: <div>
                    {/* <button className="custom-btn-primary" onClick={this.teamClicked.bind(this, team, index)}>Go Back</button> */}
                    <br />
                    <br />
                    <AvailableBets closeModal={this.closeModal.bind(this)} win={false} twoTeams={false} team={team} teamChoice={index + 1} event={event} />
                    <br />
                </div>
            });
        }
    }


    handleFinalizeCancel = (e) => {
        //console.log(e);
        this.setState({
            finalizeModalVisible: false,
        });
    }

    handleBetTypeClose = (e) => {
        //console.log(e);
        this.setState({
            betTypeModalVisible: false,
        });
    }

    onAdminMenuClick(key) {
        const { AdminStore } = this.props;
        let event = this.props.eventStore.activeEvent;
        let start_time = event.startTime;
        let duration = event.duration;
        let cancelled = event.cancelled;
        let finalized = event.finalized;

        //console.log("event " + JSON.stringify(event));
        //console.log(event.bytes32Id);
        //console.log("key" + key.key);
        if (key.key == 3) {
            (cancelled ? message.info("This event has already been cancelled.") : this.showCancelModal());
        }
        let oraclePeriodEnded = (start_time + duration + Number(AdminStore.oraclePeriod) < new Date().getTime() / 1000);
        let eventEnded = (start_time + duration < new Date().getTime() / 1000);
        if (key.key == 2) {
            (eventEnded && !oraclePeriodEnded ? this.showOracleModal() : message.info("The current time is outside the oraclize period for this event"))
        }

        if (key.key == 1) {
            (oraclePeriodEnded ? (finalized ? message.info("This event has already been finalized.") : this.showFinalizeModal()) : message.info("The oracle period has not ended, you may not finalize yet."));
        }
    }

    async componentWillMount() {
        const { AdminStore, ViewStore, TeamStore, CustomRouter, eventStore } = this.props;
        this.setState({ oracleStatus: AdminStore.getOracleStatus() }); // prompts the first retrieval
        TeamStore.queryTeams();
    }

    render() {
        const { UserStore } = this.props;
        const menu = <Menu
            // defaultSelectedKeys={['1']}
            onClick={this.onAdminMenuClick}
            defaultOpenKeys={['sub1']}
            theme="dark"
        >
            <Menu.Item key={1}>
                <Icon type="clock-circle" />
                <span>Finalize Event</span>
            </Menu.Item>
            {/* <Menu.Item key={2}>
            <Icon type="audit" />
            <span>Submit Oracle Vote</span>
        </Menu.Item> */}
            <Menu.Item key={3}>
                <Icon type="stop" />
                <span>Cancel Event</span>
            </Menu.Item>
            {/* <SubMenu key="sub1" title={<span><Icon type="mail" /><span>Navigation One</span></span>}>
        <Menu.Item key="5">Option 5</Menu.Item>
        <Menu.Item key="6">Option 6</Menu.Item>
        <Menu.Item key="7">Option 7</Menu.Item>
        <Menu.Item key="8">Option 8</Menu.Item>
    </SubMenu>
    <SubMenu key="sub2" title={<span><Icon type="appstore" /><span>Navigation Two</span></span>}>
        <Menu.Item key="9">Option 9</Menu.Item>
        <Menu.Item key="10">Option 10</Menu.Item>
        <SubMenu key="sub3" title="Submenu">
            <Menu.Item key="11">Option 11</Menu.Item>
            <Menu.Item key="12">Option 12</Menu.Item>
        </SubMenu>
    </SubMenu> */}
        </Menu>;

        const adminMenu = <Dropdown overlay={menu}>
            <button  style={{zIndex: 1}} className="custom-btn-primary">
                Admin Actions <Icon type="down" />
            </button>
        </Dropdown>;

        const doubleCheckCancelModal = <Modal
            isOpen={this.state.cancelModalVisible}
            onRequestClose={this.handleCancelCancel}
            className="custom-bet-modal"
            overlayClassName="custom-bet-modal-overlay"
        >
            <h2>Are you sure?</h2>
            <p>Are you certain you want to cancel this event? This cannot be undone.</p>
            <button onClick={this.handleCancelCancel} className="custom-btn-success">Exit</button> <button onClick={this.handleCancelOk} className="custom-btn-danger">Cancel Event</button>
        </Modal>

        const doubleCheckFinalizeModal = <Modal
            isOpen={this.state.finalizeModalVisible}
            onRequestClose={this.handleFinalizeCancel}
            className="custom-bet-modal"
            overlayClassName="custom-bet-modal-overlay"
        >
            <h2>Are you sure?</h2>
            <p>Are you certain you want to finalize this event? This cannot be undone.</p>
            <button onClick={this.handleFinalizeCancel} className="custom-btn-success">Exit</button> <button onClick={this.handleFinalizeOk} className="custom-btn-danger">Finalize Event</button>
        </Modal>

        const betTypeModal = <Modal
            isOpen={this.state.betTypeModalVisible}
            onRequestClose={this.handleBetTypeClose}
            className="custom-bet-modal"
            overlayClassName="custom-bet-modal-overlay"
        >

            {this.state.betTypeModalContent}
            <button onClick={this.handleBetTypeClose} className="custom-btn-danger">Cancel</button>
        </Modal>

        let self = this;
        const { TeamStore } = this.props;

        (self.props.CategoriesStore.categories.get(self.props.eventStore.activeEvent.categoryId) !== undefined &&
            this.state.backgroundPic === "https://i.imgur.com/bR8MBtT.jpg" ?
            self.setNewState() : console.warn("undefined cats"))

        let backgroundUrl = this.state.backgroundPic;
        let thisEvent = self.props.eventStore.activeEvent;
        const listItems = (thisEvent.teams.length < 1 ? <Icon style={{ fontSize: '62px', color: '#1890ff', padding: '10px' }} type="loading" /> :
            (thisEvent.teams.length < 2 ? <Icon style={{ fontSize: '62px', color: '#1890ff', padding: '10px' }} type="loading" />
                : thisEvent.teams.map((team) => {
                    //  console.log("team " + JSON.stringify(team));
                    let thisTeam = TeamStore.teams.get(team);
                    //  console.log("thisteam " + JSON.stringify(thisTeam));
                    return (thisTeam !== undefined ?
                        // <List.Item key={team.toString()} style={{ padding: "100px", backgroundColor: "#003252" }}>
                        //     <div style={{ color: "white" }}> {thisTeam.name}</div>
                        // </List.Item>
                        thisTeam
                        :
                        { name: team, _id: team });
                }
                )
            )
        );
        let gutterSpec;
        if (thisEvent.drawPossible) {
            gutterSpec = 1;
            listItems.push({ name: "Draw", _id: "draw", bytes32Id: "", colors: ["rgb(126,126,126)"] })
        }
        else {
            gutterSpec = 2;
        }
        return (
            <div>
                {doubleCheckFinalizeModal}
                {doubleCheckCancelModal}
                {betTypeModal}
                {(UserStore.user.role === "admin" ? adminMenu : null)}
                {thisEvent.isPropEvent ?
                    <div style={{ fontSize: "14pt", background: "rgba(0,0,0,0.6)", borderRadius: "4px", padding: "2px" }}>{thisEvent.propTitle}</div>
                    : ""
                }
                <div style={{
                    transform: "translate(1%, -0%)",
                    textAlign: "center", filter: "brightness(50%)", height: "360px", width: "98%", backgroundImage: `url(${backgroundUrl})`
                }}
                    className="single-event-page-rows-teams">
                    {/* <div style={{ position: "absolute", top: 5, left: 5, fontSize: "14pt", background: "rgba(0,0,0,0.7)", borderRadius: "4px", padding: "2px", color: "white" }}>PICK THE WINNER</div> */}

                    {/* <div className="single-event-page-rows-teams-teamone">
                    <span><img src={this.state.teamOneLogo} width="90px" /></span>
                    <div>{team_one}</div>
                    <div style={{ marginTop: '7px' }}><FollowTeamBtn teamId={this.props.team_one} /></div>
                </div> */}
                    {/* <List
                    grid={{
                        gutter: 16, xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 5,
                    }} >{listItems}</List> */}
                    <div className="single-event-page-rows-teams-vs">

                        <div style={{ marginTop: '-10px' }}>

                            {!this.state.loadingTeams ?
                                //  <Doughnut
                                //     legend={null}
                                //     width={110}
                                //     options={{
                                //         maintainAspectRatio: false
                                //     }}
                                //     height={55}
                                //     data={DoughnutData}
                                // />
                                ""
                                : <Icon style={{ fontSize: '62px', color: '#1890ff', padding: '10px' }} type="loading" />}
                        </div>
                        {/* ETH BET */}
                    </div>
                    <br />
                </div>
                {/* {listItems.map(team => {
                    return (<button
                        style={{
                            padding: "20px",
                            backgroundColor: "#003252",
                            width: "50%",
                        }}
                        onClick={self.teamClicked.bind(self, team)}
                    >
                        <div style={{ color: "white", backgroundColor: "#003252" }}><img src={team.logoUrl} />  {team.name}</div>
                    </button>)
                })     
                } */}
                <List
                    style={{
                        padding: "15px",
                        overflow: "visible",
                        position: "relative",
                        width: "100%",
                        top: -400,
                        //left: "50%",
                        //marginRight: "-50%",
                        //transform: "translate(-50%, -50%)"
                    }}
                    grid={{
                        gutter: 16, xs: 1, sm: 1, md: 1, lg: gutterSpec, xl: gutterSpec, xxl: gutterSpec,
                    }}
                    dataSource={listItems}
                    renderItem={(team, index) => (
                        <List.Item
                            style={{
                                border: "medium none",
                                display: "block",
                                margin: 0,
                                textAlign: "center",
                                width: "100%"
                            }}>
                            <div
                                style={{
                                    padding: "20px",
                                    // backgroundColor: "rgba(0,0,0,0.55)",//"#003252",
                                    width: "100%",
                                }}>
                                <div style={{ color: "white" }}>{team._id !== "draw" ? <img width="92px" src={team.logoUrl} /> : null}  {team.name}
                                    {team._id == "draw" ? <div><br /></div> : null}

                                    <div textAlign="center">
                                        <FaCoins style={{ fontSize: "24pt" }} />
                                        <br /> POOL BET
                                    <div style={{ fontSize: "14pt" }}><button onClick={self.teamClicked.bind(self, team, index, true)} className="custom-btn-primary">{team.name} {team._id == "draw" ? null : "TO WIN"}</button></div>
                                    </div>
                                    <br />                                 
                                    <div>
                                        <FaHandshake style={{ fontSize: "24pt" }} />
                                        <br />  1-1 BET
                                    <div style={{ fontSize: "14pt" }}><button onClick={this.oneToOneForTeam.bind(this, team, thisEvent, index)} className="custom-btn-primary">{team.name} {team._id == "draw" ? null : "TO WIN"}</button>
                                            <button onClick={this.oneToOneAgainstTeam.bind(this, team, thisEvent, index)} className="custom-btn">{team._id == "draw" ? "NO" : null} {team.name} {team._id == "draw" ? null : "TO LOSE"}</button></div>
                                    </div>
                                </div>
                                <br />
                                {team._id !== "draw" ? <div style={{ position: 'relative', top: '-7px' }}><FollowTeamBtn teamId={team._id} /></div> : <div></div>}
                            </div>
                            <hr style={{ width: "50%", marginLeft: "25%" }} />
                        </List.Item>
                    )}
                />               
                {/* PROTOTYPE */}
                {/* <AvailableBetTable   /> */}
                <br />
                <br />
                {/* <PropBets  originalEvent={thisEvent} eventId={thisEvent._id} relatedPropEvents={thisEvent.relatedPropEvents} /> */}
                <PropBets originalEvent={self.props.eventStore.activeEvent}
                 eventId={self.props.eventStore.activeEvent._id}
                  relatedPropEvents={self.props.eventStore.activeEvent.relatedPropEvents} />
            </div>)
    }
}
export default NewEventPage;


// WEBPACK FOOTER //
// ./src/components/layoutComponents/NewEventPage.js